import { Pipe, PipeTransform } from '@angular/core';
import { QueryCondition } from './entity/querycondition';
import { ControlType } from './entity/controltype';

@Pipe({name: 'controlType'})
export class ControlTypeXPipe implements PipeTransform {
    transform(value: QueryCondition): Array<any> {
        let type;
        switch(value.control.getControlType()){
            case ControlType.Text:
                type = 'input';
                break;
            case ControlType.Search:
                type = 'search';
                break;
            case ControlType.Date:
                type = 'date';
                break;
            case ControlType.Year:
                type = 'year';
                break;
            case ControlType.Month:
                type = 'month';
                break;
            case ControlType.MonthRange:
                type = 'monthrange';
                break;
            case ControlType.YearRange:
                type = 'yearrange';
                break;
            case ControlType.DateRange:
                type = 'daterange';
                break;
            case ControlType.DateRangeTime:
                type = 'daterangetime';
                break;
            case ControlType.DropDown:
                type = 'dropdown';
                break;
            case ControlType.NumberRange:
                type = 'number';
                break;
            case ControlType.Help:
                type = 'help';
                break;
            case ControlType.ComboLookUp:
                type= 'combolist-help';
                break;
            case ControlType.CheckboxGroup:
                type = 'checkboxgroup';
                break; 
            case ControlType.Radio:
                type = 'radio';
                break;
            case ControlType.InputGroup:
                type = 'input-group';
                break;
            default:
                type = 'input';
                break;     
        }
        return type;
    }
}
